import React from "react";
import {
  Box,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { createBlobInContainer } from "src/utils/azureBlob";

export default function AdvertBox({
  config,
  onChange,
  miniGamesData,
  dimensionsText,
}) {
  const updateSelectFilter = (filterKey, value) => {
    onChange({ ...config, [filterKey]: value });
  };

  const uploadFiles = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const imageType = event.target.dataset.imageType;
      if (!file || !imageType) return;
      const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"];
      const maxSize = 2 * 1024 * 1024;

      if (!validTypes.includes(file.type)) {
        alert("Only JPG, JPEG, PNG, WEBP, and GIF formats are allowed.");
        event.target.value = null;
        return;
      }

      if (file.size > maxSize) {
        alert("File size should not exceed 2MB.");
        event.target.value = null;
        return;
      }

      const newFileName = file.name.replace(/\s+/g, "_");
      const renamedFile = new File([file], newFileName, {
        type: file.type,
      });

      const uploadFilesAsync = async () => {
        try {
          await createBlobInContainer(renamedFile);
          const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
          const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
          const imageUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${renamedFile.name}`;

          updateSelectFilter("imageUrl", imageUrl);
        } catch (err) {
          console.error(err);
        } finally {
          event.target.value = null;
        }
      };

      uploadFilesAsync();
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle2">Display</Typography>

      <Box display="flex" gap={2} alignItems={"flex-end"} flexWrap="wrap">
        <TextField
          label="Title"
          size="small"
          variant="standard"
          value={config.title}
          onChange={(e) => updateSelectFilter("title", e.target.value)}
        />
        <FormControl size="small">
          <InputLabel>Link</InputLabel>
          <Select
            value={config.linkType}
            label="Link"
            onChange={(e) => updateSelectFilter("linkType", e.target.value)}
          >
            <MenuItem value="externalUrl">External Url</MenuItem>
            <MenuItem value="appPage">App Page</MenuItem>
            <MenuItem value="miniGames">Mini-Games</MenuItem>
          </Select>
        </FormControl>
        {config.linkType === "externalUrl" && (
          <TextField
            variant="standard"
            size="small"
            value={config.externalUrl}
            onChange={(e) => updateSelectFilter("externalUrl", e.target.value)}
            label="Url Link"
          />
        )}
        {config.linkType === "appPage" && (
          <FormControl size="small">
            <InputLabel>App Page</InputLabel>
            <Select
              style={{ minWidth: 200 }}
              value={config.appPage}
              label="App Page"
              onChange={(e) => updateSelectFilter("appPage", e.target.value)}
            >
              <MenuItem value="account">Account</MenuItem>
              <MenuItem value="prizeDraw">Prize Draw</MenuItem>
              <MenuItem value="eplUf">EPL UF</MenuItem>
              <MenuItem value="coins">Coins</MenuItem>
              <MenuItem value="packs">Packs</MenuItem>
            </Select>
          </FormControl>
        )}
        {config.linkType === "miniGames" && (
          <FormControl size="small">
            <InputLabel>Mini-Games</InputLabel>
            <Select
              style={{ minWidth: 200 }}
              value={config.miniGames}
              label="Mini-Games"
              disabled={!miniGamesData.length}
              onChange={(e) => updateSelectFilter("miniGames", e.target.value)}
            >
              {miniGamesData?.map((game, index) => (
                <MenuItem key={index} value={game.id}>
                  {game.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Box>

      {config.imageUrl ? (
        <img
          src={config.imageUrl}
          alt={`Advertisement for ${dimensionsText}`}
          width={150}
          height={150}
          style={{ marginTop: 2 }}
        />
      ) : (
        <Box
          sx={{
            marginTop: 2,
            width: 150,
            height: 150,
            borderRadius: 1,
            backgroundColor: "#f0f0f0",
            display: "flex",
            gap: 2,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CloudUpload sx={{ fontSize: 40, color: "#ccc" }} />
          <span>{dimensionsText}</span>
        </Box>
      )}
      <input
        accept="image/*"
        style={{ display: "none" }}
        id={`ads-image-${dimensionsText}`}
        type="file"
        hidden
        data-image-type={0}
        onChange={(e) => uploadFiles(e)}
      />
      <label htmlFor={`ads-image-${dimensionsText}`}>
        <Button variant="outlined" component="span" size="small" sx={{ mt: 2 }}>
          Upload Image
        </Button>
      </label>
    </Box>
  );
}
